import React, { useEffect, useState } from "react";
import PublicSection from "../../components/PublicLayer/PublicSection";
import FormHeader from "../../components/PublicLayer/FormHeader";
import useForm, { Form } from "../../components/controls/useForm";
import FormLabel from "../../components/HtmlMarkup/FormLabel";
import Controls from "../../components/controls/control";
import { useRegisterMutation } from "../../features/Auth/authApi";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../components/Ui/ErrorMessage";

const initializeValue = {
  name: "",
  email: "",
  role: "",
  password: "",
  confirmPassword: "",
};
export default function StudentRegistration() {
  const navigate = useNavigate();
  const [register, { isSuccess, isError, error }] = useRegisterMutation();
  const { values, handleInputChange, resetForm } = useForm(initializeValue);
  const [errors, setErrors] = useState(false);
  useEffect(() => {
    if (isSuccess) {
      resetForm(initializeValue);
      navigate("/coursePlayer");
    }
  }, [isSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (values?.password !== values?.confirmPassword) {
      setErrors(true);
    } else {
      register({
        name: values?.name,
        email: values?.email,
        password: values?.password,
        role: "student",
      });
    }
  };
  return (
    <PublicSection>
      <FormHeader title={"Create Your New Account"} />
      <Form onSubmit={handleSubmit} className="mt-8 space-y-6">
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <FormLabel htmlFor="name" className="sr-only">
              Name
            </FormLabel>
            <Controls.Input
              id="name"
              name="name"
              autocomplete="name"
              className="login-input rounded-t-md"
              placeholder="Student Name"
              value={values.name}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <FormLabel htmlFor="email-address" className="sr-only">
              Email address
            </FormLabel>
            <Controls.Input
              id="email-address"
              name="email"
              type="email"
              autocomplete="email"
              className="login-input "
              placeholder="Email address"
              value={values.email}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <FormLabel htmlFor="password" className="sr-only">
              Password
            </FormLabel>
            <Controls.Input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              className="login-input"
              placeholder="Password"
              value={values.password}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <FormLabel htmlFor="confirm-password" className="sr-only">
              Confirm Password
            </FormLabel>
            <Controls.Input
              id="confirm-password"
              name="confirmPassword"
              type="password"
              autocomplete="confirm-password"
              required
              className="login-input rounded-b-md"
              placeholder="Confirm Password"
              value={values.confirmPassword}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {(errors || isError) && (
          <ErrorMessage
            error={isError ? error.data : "Password not matched!"}
          />
        )}
        <div>
          <Controls.Button
            type="submit"
            text="Create Account"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
          />
        </div>
      </Form>
    </PublicSection>
  );
}
